import React, { useState } from "react"
import { useStore } from "../../teafuljs/store"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Divider from "@material-ui/core/Divider"
import Button from "@material-ui/core/Button"
import BookChapterList from "../../data/BookChapterList.json"
import VerseCounts from "../../data/verseCounts.json"
import GetSegment from "../../scripts/NavigateToSegment"
import Search from "@material-ui/icons/Search"
import Close from "@material-ui/icons/Close"
import IconButton from "@material-ui/core/IconButton"
import Info from "@material-ui/icons/Info"
import scrollToElement from "scroll-to-element"
import bibleBookList from "../../data/BookChapterList.json"
import { getTranslation } from "../../scripts/getTranslation"
import { recordEvent } from "../../apis/googleAnalytics"

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    width: "255px",
    height: "auto",
    overflowY: "auto",
  },
  bookOptions: {
    position: "relative",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: "2px",
  },
  button: {
    margin: "2px",
    width: "45px",
    height: "30px",
    textAlign: "center",
    fontSize: "80%",
    textTransform: "uppercase",
    borderRadius: "5px",
    border: "1px #19857b solid",
    color: "#19857b",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  selected: {
    backgroundColor: "#19857b",
    color: "white",
  },
  infoIcon: {
    margin: "auto",
  },
  actionPanel: {
    margin: "15px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    "& Button": {
      margin: "0 5px",
    },
  },
  divider: {
    color: "black",
    margin: "5px",
  },
  closeButtonHolder: {
    margin: 0,
    padding: 0,
  },
  closeButton: {
    position: "absolute",
    left: theme.spacing(0),
    top: theme.spacing(0),
    color: theme.palette.grey[500],
  },
  selectBookTitle: {
    position: "relative",
    width: "100%",
    marginTop: 40,
    textAlign: "center",
  },
}))

export default function ImageGridList(props) {
  const translations = useStore.translations()[0]
  const AvailableContent = useStore.AvailableContent()[0]
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const [history, setHistory] = useStore.history()
  const [searchID, setSearchID] = useStore.searchID()
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
  const [currentBook, setCurrentBook] = useStore.currentBook()
  const [refID, setRefID] = useStore.refID()
  const classes = useStyles()

  // -------------------------------------------------- //
  // -------------- STATE OF THE WEB APP -------------- //
  // -------------------------------------------------- //
  const [selectedBook, updateSelectedBook] = useState("")
  const [chapters, updateChapters] = useState(["error"])
  const [verses, updateVerses] = useState(["error"])
  const [selectedChapter, updateSelectedChapter] = useState(null)
  const [selectedVerse, updateSelectedVerse] = useState(0)

  const bibleBookOrder = Object.keys(bibleBookList)

  function getAvailableBooks() {
    let OTbooks = []
    let NTbooks = []
    const bookList = Object.keys(
      AvailableContent.content[language][version]
    )
    bookList.forEach(book => {
      if (AvailableContent.content[language][version][book]) {
        if (bibleBookOrder.indexOf(book) < 39) {
          OTbooks.push(book)
        } else {
          NTbooks.push(book)
        }
      }
    })
    OTbooks.sort(function(a, b) {
      return bibleBookOrder.indexOf(a) - bibleBookOrder.indexOf(b)
    })
    NTbooks.sort(function(a, b) {
      return bibleBookOrder.indexOf(a) - bibleBookOrder.indexOf(b)
    })
    return {
      OTbooks,
      NTbooks,
    }
  }

  const selectBook = book => {
    updateSelectedBook(book)
    if (
      AvailableContent.content[language][version][book]
        .segments.length === 1
    ) {
      updateChapters([0])
    } else {
      updateChapters([0, ...BookChapterList[book].chapters.split(",")])
    }
  }

  const deselectBook = () => {
    updateSelectedBook("")
    updateSelectedChapter()
    updateSelectedVerse(0)
  }

  const selectChapter = chapter => {
    updateSelectedChapter(parseInt(chapter))
    const verseNums = []
    for (let i = 0; i < VerseCounts[selectedBook][chapter]; i++) {
      verseNums.push(`${1 + i}`)
    }
    updateVerses(verseNums)
  }

  const deselectChapter = () => {
    updateSelectedChapter()
    updateSelectedVerse(0)
  }

  const selectVerse = verse => {
    updateSelectedVerse(parseInt(verse))
  }

  const deselectVerse = () => {
    updateSelectedVerse(0)
  }

  const search = async () => {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
      ...history,
    ])
    const chapter = selectedChapter !== null ? selectedChapter : 1
    const verse = selectedVerse !== 0 ? selectedVerse : 1
    recordEvent(
      "Search Panel Navigation",
      `${language}-${version}`,
      `(${selectedBook}-${chapter}-${verse})`
    )
    // console.log(`#ref-${selectedBook}-${chapter}-${verse}`)
    const segment = GetSegment(selectedBook, chapter, verse)
    // console.log('[search]:', segment)
    if (currentSegmentID === segment) {
      // console.log('scrolling')
      const elements = Array.from(
        document.querySelectorAll(
          `[verseref=ref-${selectedBook}-${chapter}-${verse}]`
        )
      )
      const element = elements.find(
        el =>
          !el.getAttribute("data-verse") &&
          !(
            el.getAttribute("style") &&
            el.getAttribute("style").includes("display: none")
          )
      )
      scrollToElement(element, {
        offset: -65,
        ease: "inOutCube",
        duration: 1500,
      })
      props.closeSearchMenu()
    } else {
      props.closeSearchMenu()
      if (selectedBook !== currentBook) {
        setCurrentBook(selectedBook)
      }
      if (refID !== "") {
        setRefID("")
      }
      setSearchID(`${selectedBook}-${chapter}-${verse}`)
      setCurrentSegmentID(segment)
    }
  }

  return (
    <div
      className={classes.root}
      style={language === "ARB" ? { direction: "rtl" } : {}}
    >
      <div className={classes.closeButtonHolder}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={props.closeSearchMenu}
        >
          <Close />
        </IconButton>
      </div>
      {/* <div className={classes.selectionDiv}> */}
      <Typography display="block" className={classes.selectBookTitle}>
        {getTranslation(
          translations,

          language,
          "UI",
          "search_select_book"
        )}
      </Typography>
      {selectedBook === "" ? (
        <div className={classes.bookOptions}>
          {getAvailableBooks().OTbooks ? (
            <div className={classes.bookOptions}>
              {getAvailableBooks().OTbooks.map(book => (
                <div
                  className={classes.button}
                  key={book}
                  onClick={() => selectBook(book)}
                >
                  {getTranslation(
                    translations,
                    language,
                    "Books",
                    `abbrev_${book}`
                  )}
                </div>
              ))}
            </div>
          ) : null}
          {getAvailableBooks().OTbooks ? (
            <Divider className={classes.divider} />
          ) : null}
          {getAvailableBooks().NTbooks ? (
            <div className={classes.bookOptions}>
              {getAvailableBooks().NTbooks.map(book => (
                <div
                  className={classes.button}
                  key={book}
                  onClick={() => selectBook(book)}
                >
                  {getTranslation(
                    translations,
                    language,
                    "Books",
                    `abbrev_${book}`
                  )}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      ) : (
        <div className={classes.bookOptions}>
          <div
            className={`${classes.button} ${classes.selected}`}
            key={selectedBook}
            onClick={() => deselectBook()}
          >
            {getTranslation(
              translations,
              language,
              "Books",
              `abbrev_${selectedBook}`
            )}
          </div>
        </div>
      )}
      {selectedBook !== "" ? (
        <React.Fragment>
          <Typography display="block">
            {getTranslation(
              translations,
              language,
              "UI",
              "search_select_chapter"
            )}
          </Typography>
          {!Number.isInteger(selectedChapter) && (
            <div className={classes.bookOptions}>
              <div
                className={`${classes.button} ${selectedChapter === 0 &&
                  classes.selected}`}
                key={0}
                onClick={
                  selectedChapter !== 0
                    ? () => selectChapter(0)
                    : () => deselectChapter()
                }
              >
                <Info
                  variant={selectedChapter === 0 ? "contained" : ""}
                  className={classes.infoIcon}
                />
              </div>
            </div>
          )}
          <div className={classes.bookOptions}>
            {!Number.isInteger(selectedChapter) && selectedChapter !== 0 ? (
              chapters.map((chapter, index) => {
                if (index !== 0) {
                  return (
                    <div
                      className={classes.button}
                      key={chapter}
                      onClick={() => selectChapter(parseInt(chapter))}
                    >
                      {chapter !== 0 ? (
                        chapter
                      ) : (
                        <Info className={classes.infoIcon} />
                      )}
                    </div>
                  )
                }
              })
            ) : (
              <div
                className={`${classes.button} ${classes.selected}`}
                key={selectedChapter}
                onClick={() => deselectChapter()}
              >
                {selectedChapter !== 0 ? (
                  selectedChapter
                ) : (
                  <Info variant="outlined" className={classes.infoIcon} />
                )}
              </div>
            )}
          </div>
        </React.Fragment>
      ) : null}
      {selectedBook !== "" && Number.isInteger(selectedChapter) ? (
        <React.Fragment>
          {selectedChapter !== 0 ? (
            <Typography display="block">
              {getTranslation(
                translations,
                language,
                "UI",
                "search_select_verse"
              )}
            </Typography>
          ) : null}
          <div className={classes.bookOptions}>
            {selectedVerse === 0 ? (
              verses.map(verse => (
                <div
                  className={classes.button}
                  key={verse}
                  onClick={() => selectVerse(parseInt(verse))}
                >
                  {verse}
                </div>
              ))
            ) : (
              <div
                className={`${classes.button} ${classes.selected}`}
                key={selectedVerse}
                onClick={() => deselectVerse()}
              >
                {selectedVerse}
              </div>
            )}
          </div>
        </React.Fragment>
      ) : null}
      {selectedBook !== "" ? (
        <div className={classes.actionPanel}>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => {
              deselectBook()
            }}
          >
            <Close />
          </Button>
          <Button
            id="search-function-click"
            color="primary"
            variant="contained"
            onClick={() => search()}
          >
            <Search id="search-function-click" />
          </Button>
        </div>
      ) : null}
      {/* </div> */}
    </div>
  )
}
